export default __webpack_public_path__ + "static/media/attention.a3c4b208.png";